import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  OutlinedInput,
  TextField,
} from '@mui/material';
import LoadingIndicator from '../components/Loading';
import { useLoginMutation } from '../services/rtkQueryServices';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function (props: any) {
  const [loginService, { isLoading }] = useLoginMutation();
  const [hidden, setHidden] = useState<boolean>(true);
  const [error, SetError] = useState('');
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    loginService({
      username: '' + data.get('email'),
      password: '' + data.get('password'),
    })
      .unwrap()
      .then((e: any) => SetError(''))
      .catch((e: any) =>
        SetError(`${e.data.message}, attempt ${e.data.attempt}`)
      );
  };

  return (
    <>
      <LoadingIndicator loading={isLoading} />
      <Box component='form' noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <TextField
          margin='normal'
          required
          fullWidth
          id='email'
          label='Email Address'
          name='email'
          autoComplete='email'
          autoFocus
        />
        <FormControl sx={{ width: '100%', mt: 1 }} variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-password'>
            Password *
          </InputLabel>
          <OutlinedInput
            required
            fullWidth
            name='password'
            label='Password'
            id='password'
            type={!hidden ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={() => setHidden(!hidden)}
                  onMouseDown={() => setHidden(!hidden)}
                  edge='end'
                >
                  {!hidden ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControlLabel
          control={<Checkbox value='remember' color='primary' />}
          label='Remember me'
        />
        {error && <Alert severity='error'>{error}</Alert>}
        <Button
          type='submit'
          fullWidth
          variant='contained'
          sx={{ mt: 3, mb: 2 }}
        >
          Sign In
        </Button>
      </Box>
    </>
  );
}
